import { Link } from 'react-router-dom';
import DisclaimerBanner from '@/components/DisclaimerBanner';

export default function TermsOfService() {
  return (
    <div className="min-h-screen bg-background text-foreground">
      <main className="mx-auto w-full max-w-3xl px-4 py-12 sm:px-6 lg:px-8">
        <header className="mb-12 flex items-center justify-between gap-4 border-b border-border pb-6">
          <Link to="/" className="font-playfair text-2xl font-bold tracking-tight text-foreground hover:text-primary">
            MyLegal<span className="text-primary">AI</span>
          </Link>
          <Link to="/archive" className="text-sm font-medium text-primary underline underline-offset-4">Archive notice</Link>
        </header>

        <div className="space-y-8">
          <div>
            <p className="mb-3 text-sm font-medium uppercase tracking-wider text-muted-foreground">Static archive</p>
            <h1 className="text-4xl font-bold tracking-tight">Terms and disclaimer</h1>
            <p className="mt-3 text-sm text-muted-foreground">Last updated: 30 August 2026</p>
          </div>

          <DisclaimerBanner />

          <section className="space-y-3">
            <h2 className="text-2xl font-bold">1. Archived service</h2>
            <p className="leading-relaxed text-muted-foreground">
              MyLegalAI was an experimental public-interest project. The interactive AI service is no longer accepting users. Accounts, uploads, chat, document analysis, and templates are unavailable.
            </p>
          </section>

          <section className="space-y-3">
            <h2 className="text-2xl font-bold">2. Informational material only</h2>
            <p className="leading-relaxed text-muted-foreground">
              The remaining website contains general educational material and links. It is not legal advice, is not a substitute for advice from a qualified Malaysian lawyer, and may be incomplete, outdated, or unsuitable for a particular situation.
            </p>
            <p className="leading-relaxed text-muted-foreground">
              No lawyer-client relationship is created by visiting, reading, or linking to this archive. Do not rely on it when making legal, financial, safety, or other consequential decisions without obtaining appropriate professional advice.
            </p>
          </section>

          <section className="space-y-3">
            <h2 className="text-2xl font-bold">3. External resources</h2>
            <p className="leading-relaxed text-muted-foreground">
              External organisations listed on the <Link to="/resources" className="text-primary underline underline-offset-4">resources page</Link> control their own websites and services. MyLegalAI does not guarantee their availability, accuracy, eligibility rules, response times, or suitability, and does not endorse a particular provider.
            </p>
          </section>

          <section className="space-y-3">
            <h2 className="text-2xl font-bold">4. Availability and changes</h2>
            <p className="leading-relaxed text-muted-foreground">
              The archive is provided as-is for public reference. Pages, links, and hosting may change or be removed without notice. Nothing on this site creates an obligation to provide an interactive service or ongoing support.
            </p>
          </section>

          <section className="space-y-3">
            <h2 className="text-2xl font-bold">5. Governing law</h2>
            <p className="leading-relaxed text-muted-foreground">
              These terms are intended to be read subject to the laws of Malaysia. Obtain independent legal advice about how any legal issue applies to you.
            </p>
          </section>
        </div>

        <footer className="mt-12 flex gap-4 border-t border-border pt-8 text-sm">
          <Link to="/privacy" className="flex-1 rounded-lg border border-border px-4 py-3 text-center text-primary hover:bg-muted">Privacy policy</Link>
          <Link to="/" className="flex-1 rounded-lg bg-primary px-4 py-3 text-center text-primary-foreground hover:bg-primary/80">Back to archive</Link>
        </footer>
      </main>
    </div>
  );
}
